import cx from "classnames";
import {
  ActionBlock,
  Header,
  TranslatedString,
  LogoutModal,
  Button,
  Card,
  FlexBox,
  Input,
} from "components";
import {
  globalConstant,
  sideMenuList,
  SIDE_MENU_CUSTOM_ACTIONS,
} from "../../../constants";
import React, { useEffect, useState } from "react";
import "./styles.scss";
import { SideMenuProps } from "./types";
import {
  ChangeHistory,
  EventManager,
  EventNames,
  nameFunctions,
  validateEmail,
} from "utils";
import {
  registerClientApi,
  setGeneralDetails,
  useGeneralDetails,
  useRegisterClientApiDetails,
} from "Slices";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import ROUTE_PATH from "Routes/paths";
const SideMenu: React.FC<SideMenuProps> = ({ isOpened, menuCloseCallback }) => {
  //Dispatch
  const dispatch = useDispatch();

  const [isMenuOpened, setIsMenuOpened] = useState(false);
  const [logoutModalVisibility, setLogoutModalVisibility] = useState(false);
  const [email, setEmail] = useState("");
  const [userRegistered, setUserRegistered] = useState(false);

  //Selectors
  const registerClientDetails = useRegisterClientApiDetails();

  useEffect(() => {
    setUserRegistered(
      registerClientDetails?.data?.status === "SUCCESS" &&
        !registerClientDetails?.data?.isExist
    );
    if (
      registerClientDetails?.data?.status === "SUCCESS" &&
      registerClientDetails?.data?.isExist
    ) {
      const endPath = window.localStorage.getItem("token")
        ? "ACTIVITY"
        : "SIGNUP_LOGIN";

      ChangeHistory("push", ROUTE_PATH.DASHBOARD[endPath]);
    }
  }, [registerClientDetails]);

  const onClick = (item: any) => {
    EventManager.send(
      EventNames.EVENTS_NAME.WEBSITE.HEADER?.[item["eventName"]]
    );
    if (item["onClick"].includes("/")) ChangeHistory("push", item["onClick"]);
    else
      switch (item["onClick"]) {
        case SIDE_MENU_CUSTOM_ACTIONS.REFER:
          break;

        case SIDE_MENU_CUSTOM_ACTIONS.INTEGRATION:
          ChangeHistory("push", ROUTE_PATH.DOCS.HOME);
          break;

        case SIDE_MENU_CUSTOM_ACTIONS.RATE:
          break;

        case SIDE_MENU_CUSTOM_ACTIONS.LOGOUT:
          setLogoutModalVisibility(true);
          break;
          break;

        default:
          break;
      }
  };

  const registerClient = () => {
    if (validateEmail(email)) {
      setGeneralDetails({
        email,
      });
      dispatch(
        registerClientApi({
          email,
        })
      );
    } else {
      toast.error("Please enter your work email.");
    }
  };

  const returnActionBlock = (item: any, index: number) => {
    return (
      <p
        onClick={() => onClick(item)}
        className="animated fadeInRight text-center fs-16 font-heavy pd-20 border-bottom"
        key={`side-menu-${index}`}
      >
        {item["text"]}
      </p>
    );
  };
  return (
    <div className={cx(isOpened && "side-menu-opened", "side-menu")}>
      <div className="side-menu-options">
        {sideMenuList?.map(returnActionBlock)}
        <Button
          text={window.localStorage.getItem("token") ? "Dashboard" : "Login"}
          className="mr-t-20 pd-v-10 pd-h-20 z-1 pos-rel w-100"
          onClick={() => {
            const endPath = window.localStorage.getItem("token")
              ? "ACTIVITY"
              : "SIGNUP_LOGIN";

            ChangeHistory("push", ROUTE_PATH.DASHBOARD[endPath]);
          }}
        />
        {/* <div className="border-top mr-t-40">
          <div className="get-api br-12 pd-15 bg-theme w-80 animated fadeInUp delay-05s">
            <div className="w-100 pd-l-10">
              <Input
                type={"text"}
                onChange={(e) => setEmail(e.target.value)}
                value={email}
                placeholder={"Enter Your Work Email"}
              />
            </div>
            <Button
              text={`Sign up now`}
              className="br-60 clr-white w-100 mr-t-20 no-wrap "
              onClick={() => registerClient()}
            />
          </div>
        </div> */}
      </div>
      <LogoutModal
        visible={logoutModalVisibility}
        onClose={() => {
          setLogoutModalVisibility(false);
        }}
        logoutAction={() => {
          // do logout
        }}
      />
    </div>
  );
};
export default SideMenu;
